import * as yup from "yup";

const BankInformationSchema = yup.object().shape({
  bank_account_name: yup
    .string()
    .trim()
    .matches(
      /^([a-zA-Z]+\s)*[a-zA-Z]*$/,
      "Numbers, special characters not allowed in bank account name!!"
    )
    .max(35, "Bank account name should be less than 35")
    .required("Bank account name is required and must be valid"),
  bank_ifsc_code: yup
    .string()
    .trim()
    .matches(
      /^[A-Z0-9]*$/,
      "IFSC code must contain alphanumeric characters only (in capital)"
    )
    .max(11, "IFSC code name should be less than 11")
    .required("IFSC code required and must be valid"),
  bank_account_number: yup
    .string()
    .trim()
    .matches(/^[0-9]*$/, "Bank account number must contain numbers only")
    .max(18, "Bank account number name should be less than 18")
    .required("Bank account number required and must be valid"),
  gst_number: yup
    .string()
    .trim()
    .matches(
      /^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$/,
      "GSTIN Number is invalid"
    )
    .max(15, "GSTIN Number name should be less than 15"),
  bank_account_number_confirm: yup
    .string()
    .trim()
    .when("bank_account_number", {
      is: (val) => val == undefined,
      then: yup
        .string()
        .required("Confirm bank account")
        .oneOf(
          [yup.ref("bank_account_number")],
          "Account Id cannot be blank!!"
        ),
    })
    .when("bank_account_number", {
      is: (val) => !!(val && val.length > 0),
      then: yup
        .string()
        .oneOf(
          [yup.ref("bank_account_number")],
          "Account Number doesn't match please confirm!!"
        ),
    })
    .required("Please Confirm your Bank Account Number"),
});

export default BankInformationSchema;
